import { DbCloudWallet } from '@shared/types/db/user';
import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useSession } from '@/contexts/LitSessionProvider';
import { queryClient } from '@/pages/_app';
export default function useGetNotificationSettings() {
  const {
    PKP
  } = useSession();
  const {
    data: notificationSettings,
    isLoading
  } = useQuery({
    queryKey: ['userNotificationSettings'],
    queryFn: async (): Promise<DbCloudWallet['notification_config'] | undefined> => {
      const data = await fetch('/api/notifications/settings').then(res => res.json());
      return data;
    },
    enabled: !!PKP?.ethAddress
  });
  const {
    mutate: updateNotificationSettings
  } = useMutation({
    mutationFn: async (settings: DbCloudWallet['notification_config']) => {
      const response = await fetch('/api/notifications/settings', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          notification_config: settings
        })
      });
      if (!response.ok) {
        const error = await response.json();
        toast.error(error.message || 'Failed to update notification settings');
      }
      return await response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['userNotificationSettings']
      });
    },
    onError: error => {
      console.error('Error updating notification settings:', error);
    }
  });
  return {
    notificationSettings,
    isLoading,
    updateNotificationSettings
  };
}